import React from "react";
import CardContainer from "../Containers/CardContainer";
import SentenceCard from "../Cards/SentenceCard";
import Heading from "../Headers/Heading";

const ExampleSentences = ({ englishSentence, bengaliSentence }) => {
  return (
    <CardContainer className="p-6">
      <Heading>বাক্যে ব্যবহার</Heading>
      <div className="space-y-3">
        <SentenceCard
          header="ইংরেজি"
          sentence={englishSentence}
          color="gray"
        />
        <SentenceCard
          header="বাংলা"
          sentence={bengaliSentence}
          color="indigo"
        />
      </div>
    </CardContainer>
  );
};

export default ExampleSentences;
